const state = {
    coupons:[],
};

const getters = {
    coupons: state => state.coupons,
};

const actions = {
    getCoupons({commit, state}){
        axios.get('/api/admin/coupon').then((response) => {
            commit('setCoupons', response.data.data);
        })
    }
};

const mutations = {
    setCoupons(state, coupons){
        state.coupons = coupons;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
